import React from "react";
import "./IconList.scss";
import { ReactSVG } from "react-svg";

const IconList = (props) => {

    const { list } = props;

    return (
        <div className="iconList">
            {list.map((item, index) => {
                return (
                    <div key={index} className="item">
                        <ReactSVG src={item.icon} />
                        <span>{item.text}</span>
                    </div>
                )
            })}
        </div>
    );
}

export default IconList;